define('form/sort',['jquery', 'jqueryui/widgets/sortable'], function ($) {
	
	var Sort = function (settings) {
		var $this = this;
		this.settings = $.extend({
			element : null,
			params : {}
		}, settings);
	
		this.init = function () {
			
			var active = null;
			
			$('#list ul').sortable({
				 connectWith: '#list ul',
	             placeholder: "ui-state-highlight",
	             handle: '.move',
	             
	             update : function(event, ui) {
	            	 
	 				if(ui.item != active) {
	 					active = ui.item;
	 					
	 					function toArray(item) {
	 	 					var ret = [];
	 	 					item.find('ul li').each(function () {
	 	 						
	 	 						ret.push({
	 	 							id : $(this).data('id'), 
	 	 							children : toArray($(this))
	 	 						});
	 	 						
	 	 					});
	 	 					
	 	 					return ret;
	 	 				};
	 	
	 					$.post($.url('sort', $this.settings.params), {
	 	 					sort : toArray( $('#list') )
	 	 				}, function (data) {
	 	 					// TODO To logger and log or something...
	 	 					active = null;
	 	 				});
	 				}
	 			}
			});
			
		};
		
		this.init();
	};
	
	
	/**
	 * jQuery variant op Sort
	 * .data(sort) == Sort
	 */
	$.fn.listSort = function (global_settings) {
		
		return this.each(function () {
			var el = $(this);
			var obj = new Sort($.extend( {element: el }, global_settings));
			el.data('sort', obj);
			return el;
		});
	};
	
	return Sort;
});
